"use client";


import { useDispatch } from "react-redux";
import { AppDispatch } from "../../feature/store/store";
import { useEffect } from "react";

import {
  checkAccessTokenApi,
  displayUserById,
  setUserId,
  setUserInfo,
} from "../../feature/reducers/userSlice";

interface LayoutProps {
  children: React.ReactNode;
}

export default function MainLayout({ children }: LayoutProps) {
  const dispatch = useDispatch<AppDispatch>();



  useEffect(() => {
    const userId = localStorage.getItem("userId") || "";
    if (userId) {
      dispatch(setUserId(userId));
    } else {
      dispatch(setUserInfo(null));
      dispatch(setUserId(""));
    }
  }, [dispatch]);

  useEffect(() => {
    const checkUserIsLogin = async () => {
      try {
        await dispatch(checkAccessTokenApi()).unwrap();
        const userId = localStorage.getItem("userId") || "";
        if (userId) {
          dispatch(setUserId(localStorage.getItem("userId") || ""));
        }
      } catch (error: any) {
        localStorage.clear();
        dispatch(setUserId(""));
      }
    };
    checkUserIsLogin();
  }, []);

  return (
    <main className="relative z-10">
      <div className="min-h-screen">{children}</div>
    </main>
  );
}
